// Is the viewer "at the live edge" of a live HLS stream?
//
// hls.js moves liveSyncPosition in steps: once per playlist refresh, by a
// whole segment, while currentTime advances smoothly. Right after a refresh
// the viewer is momentarily a segment behind, so a fixed 3 s threshold made
// the badge flicker between LIVE and "LIVE -0:03". The threshold therefore
// scales with the segment length, and leaving the edge needs one more
// segment of lag than entering it (hysteresis): only a real rewind, a pause
// or a stall drops the viewer off the edge.

const MIN_TOLERANCE_SECONDS = 8;
const DEFAULT_TARGET_DURATION_SECONDS = 6;

export function liveEdgeTolerance(targetDuration: number | null): number {
  const segment =
    targetDuration != null && targetDuration > 0
      ? targetDuration
      : DEFAULT_TARGET_DURATION_SECONDS;
  return Math.max(MIN_TOLERANCE_SECONDS, 2 * segment);
}

export function isAtLiveEdge(params: {
  wasAtEdge: boolean;
  liveEdge: number | null;
  currentTime: number;
  targetDuration: number | null;
}): boolean {
  const { wasAtEdge, liveEdge, currentTime, targetDuration } = params;
  if (liveEdge == null) return false;
  const lag = liveEdge - currentTime;
  const tolerance = liveEdgeTolerance(targetDuration);
  const segment =
    targetDuration != null && targetDuration > 0
      ? targetDuration
      : DEFAULT_TARGET_DURATION_SECONDS;
  return lag <= (wasAtEdge ? tolerance + segment : tolerance);
}
